import React from 'react';
import ApiTable, {TableProps} from 'shared/migration-components/api-table';
import useListState, {AnalyticsCardListProps} from './state';

import TitleBar, {TitleBarProps} from 'shared/migration-components/title-bar';
import DateFilter from 'shared/components/date-filter';
import {NestedKeys} from 'shared/types/key-manipulation';
import AnalyticsCard from 'shared/migration-components/analytics-card';

import {Container} from './styles';

interface ListTableProps<T> extends Omit<TableProps<T>, 'inifityQuery'> {}

interface ListProps<T> {
  titleBar: TitleBarProps;
  table: ListTableProps<T>;
  queryKey?: any;
  extraParams?: any;
  ExtraComponent?: React.ReactNode;
  dateFilter?: {
    startDateField: NestedKeys<T>;
    dateTime?: boolean;
  };
  analyticsCards?: AnalyticsCardListProps[];
  fixedColumns?: NestedKeys<T>[];
  canExportData?: boolean;
}

const List: <T>(P: ListProps<T>) => React.ReactElement<T> = ({
  table,
  titleBar,
  queryKey,
  extraParams,
  ExtraComponent,
  dateFilter,
  fixedColumns,
  canExportData,
  ...props
}) => {
  const {onChangeDate, defaultValues, ...inifityQuery} = useListState(
    table,
    queryKey,
    extraParams,
    dateFilter?.startDateField,
    fixedColumns,
  );

  const data = inifityQuery.data?.pages[0];

  const analyticsCards = props.analyticsCards?.map(
    ({field, ...analyticsCard}) => ({
      ...analyticsCard,
      value: data
        ? (typeof field === 'string' ? data[field] : field(data)) ?? 0
        : 0,
    }),
  );

  const getToolBar = () => {
    const toolBar = table.toolbar ?? [];

    return toolBar;
  };

  const getDefaultDateFilter = () => {
    const filters = table.projection.filter?.filters;
    if (!filters || !dateFilter) return;

    const filter = filters[dateFilter?.startDateField];

    return typeof filter === 'string' ? JSON.parse(filter) : filter;
  };

  return (
    <Container>
      <TitleBar {...{...titleBar, inifityQuery}} />
      {dateFilter && (
        <DateFilter
          {...{
            onFilterChange: onChangeDate,
            defaultValues: getDefaultDateFilter(),
            startDateField: dateFilter.startDateField,
            dateTime: dateFilter.dateTime,
          }}
        />
      )}
      {analyticsCards && <AnalyticsCard data={analyticsCards} />}
      {ExtraComponent}
      <ApiTable
        {...{
          ...table,
          toolbar: getToolBar(),
          inifityQuery,
          canExportData,
          extraParams,
        }}
      />
    </Container>
  );
};

export default List;
